/**
 * 站点的设备管理权限
 * SITE_MANAGE("0")
 *
 * 站点的信息管理权限
 * SITE_INFO("1")
 *
 * 站点的创建权限
 * SITE_CREATE("2")
 *
 * 站点的删除权限
 * SITE_DELETE("3")
 *
 * 站点的分配权限
 * SITE_ASSIGN("4")
 *
 * 账号和角色管理权限
 * SECURITY("5")
 *
 * 公司信息管理权限
 * COMPANY_INFO("6")
 *
 * 站点管理管理权限（包含0，1，2，3，4）
 * SITE_ALL("7")
 *
 * 账单支付，订单查看权限
 * COMPANY_BILL("8")
 *
 * 运维package权限
 * COMPANY_PACKAGE("9")
 *
 *
 * **/
import storage from '@pro/common/dao/storage';
import Vue from 'vue';
import { INSTALLER_SECOND_PERMISSION } from '@pro/common/constant.js';

let permission = null;
// let ability = null;
let regionCode = null;
let juridicalPersonFlag = null;
let userInfo = null;
let epConuntrySettings = null;
let grayscaleFunctions = null;
let dictionary = storage.get(storage.NAME.DICTIONARY);
const getPermission = function () {
  const user = storage.get(storage.NAME.USER);
  dictionary = storage.get(storage.NAME.DICTIONARY);
  epConuntrySettings = storage.get('epConuntrySettings');
  userInfo = user;
  permission = user.permissions || [];
  // ability = storage.get(storage.NAME.ABILITY);
  regionCode = user.regionCode;
  juridicalPersonFlag = user.juridicalPersonFlag;
  grayscaleFunctions = user.grayscaleFunctions || [];
};

class Permission {
  get siteDeviceManage() {
    getPermission();
    return permission.includes('0') || permission.includes('7');
  }
  get siteInfo() {
    getPermission();
    return permission.includes('1') || permission.includes('7');
  }
  get siteCreate() {
    getPermission();
    return permission.includes('2') || permission.includes('7');
  }
  get siteDelete() {
    getPermission();
    return permission.includes('3') || permission.includes('7');
  }
  get accountAndRole() {
    getPermission();
    return permission.includes('5');
  }
  get companyInfo() {
    getPermission();
    return permission.includes('6');
  }
  get ManageAssignedSite() {
    return (
      permission.includes('0')
      && permission.includes('1')
      && permission.includes('2')
      && permission.includes('3')
      && permission.includes('9')
    );
  }
  get siteManage() {
    getPermission();
    return permission.includes('0');
  }
  get arcManagerPermission() {
    getPermission();
    return permission.includes('38');
  }
  get siteAll() {
    getPermission();
    return permission.includes('7');
  }
  get bill() {
    getPermission();
    return (
      permission.includes('8')
      && (storage.get(storage.NAME.USER).realAuthFlag === 1 || storage.get(storage.NAME.USER).realAuthFlag === 2)
    );
  }
  get auth() {
    return storage.get(storage.NAME.USER).realAuthFlag === 1 || storage.get(storage.NAME.USER).realAuthFlag === 2;
  }
  get pureBill() {
    getPermission();
    return permission.includes('8');
  }
  get package() {
    getPermission();
    return (
      permission.includes('9')
      || permission.includes('0')
      || permission.includes('1')
      || permission.includes('2')
      || permission.includes('3')
      || permission.includes('7')
    );
  }
  get eventCenterPermission() {
    getPermission();
    return permission.includes('8') || permission.includes('0') || permission.includes('7');
  }
  get deviceLinkage() {
    // 由于enableDeviceLinkage字段废弃，该判断更改为始终返回true
    // getPermission();
    // return ability.enableDeviceLinkage;
    return true;
  }
  get healthCheck() {
    // 由于enableHealthCheck字段废弃，该判断更改为始终返回true
    return true;
    // getPermission();
    // return ability.enableHealthCheck;
  }
  get isEurope() {
    getPermission();
    return regionCode === 'EU_WEST_1';
  }
  get isNorthAmerica() {
    getPermission();
    return regionCode === 'NA_WEST_1';
  }
  get isjuridicalPerson() {
    getPermission();
    return juridicalPersonFlag;
  }
  get eventCenter() {
    // 由于enableHealthCheck字段废弃，该判断更改为始终返回true
    return true;
    // getPermission();
    // return ability.enableEventPush;
  }
  get showInFree() {
    getPermission();
    return grayscaleFunctions.includes(4) && !grayscaleFunctions.includes(5);
  }
  get disabledInFree() {
    getPermission();
    return grayscaleFunctions.includes(5);
  }
  get hasEmployee() {
    return storage.get(storage.NAME.USER).hasEmployee;
  }
  get isEPUser() {
    getPermission();
    return userInfo.originType === 2;
  }
  get isSyscomUser() {
    getPermission();
    return userInfo.originType === 1;
  }
  get isMexico() {
    getPermission();
    return userInfo.country === '143';
  }
  get isEcuador() {
    getPermission();
    return userInfo.country === '79';
  }
  get hasRemoteConfigSecondAuth() {
    //远程配置
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.REMOTE_CONFIG);
  }
  get hasVideoPreviewSecondAuth() {
    //视频预览
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.VIDEO_PREVIEW);
  }
  get hasVideoPlaybackSecondAuth() {
    //视频回放
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.VIDEO_PLAYBACK);
  }
  get hasAxproDeploymentSecondAuth() {
    //axpro布防
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.AXPRO_DEPLOYMENT);
  }
  get hasAxproDisarmSecondAuth() {
    //axpro撤防(消警)
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.AXPRO_DISARM);
  }
  get hasAxproBypassSecondAuth() {
    //axpro旁路
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.AXPRO_BYPASS);
  }
  get hasAxecoAreasSecondAuth() {
    //某员工对于其下的axeco的布撤防权限，不细分布防还是撤防
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.AXECO_AREAS);
  }
  get hasAXecoSystemManagementSecondAuth() {
    return permission.includes(INSTALLER_SECOND_PERMISSION.AXECO_SYSTEM_MANAGEMENT);
  }
  get hasAXProAreasSecondAuth() {
    return permission.includes(INSTALLER_SECOND_PERMISSION.AREAS_SETTINGS_MANAGEMENT);
  }
  get isAustraliaCountry() {
    getPermission();
    return userInfo.australiaCountry;
  }
  get hasBatchInviteHCAccountSecondAuth() {
    //批量邀请终端用户
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.BATCH_INVITE_HC_ACCOUNT);
  }
  get accessCloudPackage() {
    // 云存储套餐赠送支持
    getPermission();
    if (!(dictionary && dictionary.length > 0)) {
      return true;
    }
    const data = dictionary.find((x) => [82].includes(x.type));
    if (data) {
      return data.value !== '1';
    }
    return true;
  }
  get isBindOEMDistributor() {
    //批量邀请终端用户
    getPermission();
    if (!(dictionary && dictionary.length > 0)) {
      return false;
    }
    const data = dictionary.find((x) => [84].includes(x.type));
    if (data) {
      return data.value === '1';
    }
    return false;
  }
  get showOrderQuote() {
    getPermission();
    return epConuntrySettings?.quoteConvertOrderSwitch;
  }
  // cobranding能力集为反向获取，即开了此灰度，代表无权限
  get isCoBrandingAblityReverse() {
    getPermission();
    if (!(dictionary && dictionary.length > 0)) {
      return false;
    }
    const data = dictionary.find((x) => [156, 157].includes(x.type));
    if (data) {
      return data.value === '1';
    }
    return false;
  }
  // b2c能力集为反向获取，即开了此灰度，代表无权限
  get isB2cAblityReverse() {
    getPermission();
    if (!(dictionary && dictionary.length > 0)) {
      return false;
    }
    const data = dictionary.find((x) => [160, 161].includes(x.type));
    if (data) {
      return data.value === '1';
    }
    return false;
  }
  //删除设备权限
  get canDeleteDevice() {
    getPermission();
    return permission.includes('39');
  }
  //无站点权限(Manage All Sites或者Manage Assigned Sites都没有)
  get noSiteAuth() {
    getPermission();
    return !permission.includes('7') && !permission.includes('4');
  }
  get hasPircamPermission() {
    // nexecur员工抓图权限(非nexecur时服务不返回)
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.PIRCAM);
  }
  //User Management权限
  get hasUserManagementAuth() {
    getPermission();
    return permission.includes(INSTALLER_SECOND_PERMISSION.USER_MANAGEMENT);
  }
}

class Basic {
  get isOneHikIdUser() {
    getPermission();
    return !!userInfo.oneHikId;
  }
  get isUpgrade() {
    getPermission();
    return userInfo.upgradeFlag;
  }
  get installerId() {
    getPermission();
    return userInfo.installerId;
  }
  get PassengerFlowSupport() {
    getPermission();
    if (!(userInfo.dictionary && userInfo.dictionary.length > 0)) {
      return false;
    }
    const data = userInfo.dictionary.find((x) => x.type === 11);
    if (data) {
      return data.enable;
    }
    return false;
  }
  get thermonmetrySupport() {
    getPermission();
    if (!(userInfo.dictionary && userInfo.dictionary.length > 0)) {
      return false;
    }
    const data = userInfo.dictionary.find((x) => x.type === 13);
    if (data) {
      return data.enable;
    }
    return false;
  }
  get accessAndAttendanceSupport() {
    // 云考勤支持
    getPermission();
    if (!(userInfo.dictionary && userInfo.dictionary.length > 0)) {
      return false;
    }
    const data = userInfo.dictionary.find((x) => [35, 36].includes(x.type));
    if (data) {
      return data.enable;
    }
    return false;
  }
  get onlineBuySupport() {
    getPermission();
    return userInfo.payMethod === '0' || userInfo.payMethod === '2';
  }
  get licenseBuySupport() {
    getPermission();
    return userInfo.payMethod === '1' || userInfo.payMethod === '2';
  }
  get isAuthed() {
    getPermission();
    return [1, 2].includes(parseInt(userInfo.realAuthFlag, 10));
  }
  get isAuthing() {
    getPermission();
    return parseInt(userInfo.realAuthFlag, 10) === 3;
  }
}

class GrayscaleFunctions {
  get supportCloudStorage() {
    getPermission();
    return grayscaleFunctions.includes(2); //是否支持云存储
  }

  get supportDPP() {
    getPermission();
    return grayscaleFunctions.includes(9);
  }
}

export const permissionInstantce = new Permission();
export const basicInstantce = new Basic();
export const grayscaleFunctionsInstantce = new GrayscaleFunctions();

Vue.prototype.$permission = permissionInstantce;
Vue.prototype.$basic = basicInstantce;
Vue.prototype.$grayscaleFunctions = grayscaleFunctionsInstantce;

export default permissionInstantce;
